<template>
  <div class="custom-filter-bar" :style="mergedTheme.container" v-if="filterVisibleFields.length > 0">
    <section class="custom-filter-bar__container" @mousedown.stop>
      <template v-for="(filter, index) in filterVisibleFields">
        <template v-if="filter.type === 'select' || filter.type === 'treeselect'">
          <div :key="filter.type + index" class="custom-filter-bar__field"
            :class="{ 'custom-filter-bar__field--opened': index == indexSelectedFilter }">
            <a class="custom-filter-bar__field-button" :style="mergedTheme.common" @mousedown="openFilterDetail(index)">
              <i v-if="filter.icon" :class="filter.icon" aria-hidden="true"></i>
              <i v-else class="fa fa-list" aria-hidden="true"></i>
              <span>{{ filter.label }}</span>
            </a>
            <div class="custom-filter-bar__field-content">
              <div v-if="filter.type == 'select'" class="margin-bot select-v">
                <v-select v-model="local[filter.field]" :multiple="true" :options="filter.options"
                  :reduce="(option) => option.id" :placeholder="filter.placeholder || ''" label="label" key="id">
                  <template #no-options="{ search, searching, loading }">{{ $t("filter_bar.v_select.no_results")
                  }}</template>
                </v-select>
              </div>
              <div v-if="filter.type == 'treeselect'" class="margin-bot select-v">
                <treeselect v-model="local[filter.field]" :multiple="true" :options="filter.options"
                  :placeholder="filter.placeholder || ''" :noChildrenText="$t('filter_bar.v_select.no_results')"
                  :noOptionsText="$t('filter_bar.v_select.no_results')"
                  :noResultsText="$t('filter_bar.v_select.no_results')"></treeselect>
              </div>
              <div class="btnGroup-end">
                <a class="btnPrimary-s" :style="mergedTheme.filterButton" @mousedown="onFilter()">
                  {{ $t("filter_bar.button.filter") }}
                </a>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="filter.type === 'input'">
          <div :key="filter.type + index" class="custom-filter-bar__input-container" :style="mergedTheme.common"
            @mousedown="closeFilterDetail()">
            <i v-if="filter.icon" :class="filter.icon" aria-hidden="true"></i>
            <i v-else class="fa fa-list" aria-hidden="true"></i>
            &nbsp;{{ filter.label }}&nbsp;
            <input v-model="local[filter.field]" type="text" style="margin: 0 !important"
              :placeholder="filter.placeholder || ''" class="input-small" @keyup.enter="onFilter()"
              autocomplete="off" />
          </div>
        </template>
      </template>
    </section>
    <section v-if="filterChips.length > 0" class="custom-filter-bar__active-filters">
      <template v-for="(filterChip, index) in filterChips">
        <div class="custom-filter-bar__chip" :style="mergedTheme.chip" :key="`${filterChip.field}_chip_${index}`">
          <i v-if="filterChip.icon" class="custom-filter-bar__chip-icon" :class="filterChip.icon"></i>
          <i v-else class="custom-filter-bar__chip-icon fa fa-list"></i>
          <span class="custom-filter-bar__chip-text">{{ filterChip.label }}</span>
          <i class="custom-filter-bar__chip-icon-close material-icons"
            @mousedown="deleteFilter(filterChip.field, filterChip.key)">close</i>
        </div>
      </template>
    </section>
  </div>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

const DEFAULT_THEME = {
  container: {
    border: "1px solid #dedede",
  },
  common: {
    backgroundColor: "#fff",
    color: "#463577",
  },
  chip: {
    backgroundColor: "#eee8fc",
    color: "#463577"
  },
  filterButton: {
    backgroundColor: "#463577",
    color: "#fff",
  },
};

export default {
  name: "CustomFilterBar",
  components: {
    Treeselect,
    vSelect
  },
  props: {
    value: {
      type: Object
    },
    filterFields: {
      type: Array,
      default: []
    },
    theme: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data() {
    return {
      indexSelectedFilter: null,
      filterChips: [],
    };
  },
  created() {
    document.addEventListener('mousedown', (event) => {
      this.closeFilterDetail();
    });
  },
  watch: {
    local: {
      handler() {
        this.$emit('input', this.local);
        if (Object.entries(this.local).length === 0) {
          this.filterChips = [];
        }
      },
      deep: true
    },
    filterFields: {
      handler() {
        this.setFilterChips();
      },
      deep: true
    }
  },
  computed: {
    local() {
      return this.value ? this.value : {};
    },
    mergedTheme() {
      return {
        ...DEFAULT_THEME,
        ...this.theme
      }
    },
    filterVisibleFields() {
      return this.filterFields.filter((field) => field.visible)
    },
  },
  methods: {
    openFilterDetail(index) {
      if (this.indexSelectedFilter == index) {
        this.indexSelectedFilter = null;
      } else {
        this.indexSelectedFilter = index;
      }
    },
    closeFilterDetail() {
      this.indexSelectedFilter = null;
    },
    deleteFilter(field, key) {
      const filterField = this.filterFields.find((filterField) => filterField.field === field);
      if (filterField.type === 'input') {
        this.local[field] = '';
      } else {
        this.local[field].splice(this.local[field].indexOf(key), 1);
      }
      this.onFilter();
    },
    onFilter() {
      this.$emit("filter", this.local);
      this.closeFilterDetail();
      this.setFilterChips();
    },
    setFilterChips() {
      this.filterChips = [];
      for (const field in this.local) {
        const filterField = this.filterFields.find((filterField) => filterField.field === field);
        if (filterField.type === 'input') {
          if (this.local[field]) {
            this.filterChips.push({
              field: field,
              fieldType: filterField.type,
              icon: filterField.icon || '',
              key: this.local[field],
              label: this.local[field]
            });
          }
        } else {
          this.local[field].forEach(key => {
            this.filterChips.push({
              field: field,
              fieldType: filterField.type,
              icon: filterField.icon || '',
              key: key,
              label: this.getFilterFieldLabel(field, key)
            });
          });
        }
      }
    },
    getFilterFieldLabel(field, key) {
      const filterField = this.filterFields.find(({ field: f }) => f === field);
      switch (filterField.type) {
        case 'select':
          return (filterField.options.find(({ id }) => id === key) || {}).label || key;
        case 'treeselect':
          return (this.findInTree(filterField.options, key) || {}).label || key;
        default:
          return key;
      }
    },
    findInTree(tree, key) {
      for (const node of tree) {
        if (node.id === key) {
          return node;
        }
        if (node.children) {
          const subnode = this.findInTree(node.children, key);
          if (subnode) return subnode;
        }
      }
    },
  },
};
</script>
